(function () {
    'use strict';

    angular.module("imApp").factory("productBomService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1129,
                    parameters: parms || {}
                });
            },
            listProductBoms: function (parms) {
                return $ihttp.post({
                    method: 1130,
                    parameters: parms || {}
                });
            },
            listIncludedIn: function (parms) {
                return $ihttp.post({
                    method: 1137,
                    parameters: parms || {}
                });
            },
            listOwns: function (parms) {
                return $ihttp.post({
                    method: 2930,
                    parameters: parms || {}
                });
            },
            listDocuments: function (parms) {
               return $ihttp.post({
                   method: 309,
                   parameters: parms || {}
               });
            },
            listAssemblyGroups: function (parms) {
                return $ihttp.post({
                    method: 3238,
                    parameters: parms || {}
                });
            },
            updateBom: function (edit) {
                return $ihttp.post({
                    method: 3180,
                    parameters: edit
                });
            },
            getProdIdSelected: function (edit) {
                return $ihttp.post({
                    method: 1135,
                    parameters: edit
                });
            },
            checkProduct: function (mergeObj) {
                return $ihttp.post({
                    method: 2314,
                    parameters: mergeObj
                });
            },
            saveAssemblyGroup: function (edit) {
                return $ihttp.post({
                    method: 3239,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
